export const globalStates = {
  INTRO: "GLOBAL_INTRO",
  ROUNDS: "GLOBAL_ROUNDS",
  OUTRO: "GLOBAL_OUTRO",
}

export const roundStates = {
  INTRO: "ROUND_INTRO",
  PLAYER_TURNS: "ROUND_PLAYER_TURNS",
  REDISTRIBUTE: "ROUND_REDISTRIBUTE",
  OUTRO: "ROUND_OUTRO",
}

export const turnStatesSolo = {
  INTRO: "TURN_SOLO_INTRO",
  QUESTION: "TURN_SOLO_QUESTION",
  PREVIEW: "TURN_SOLO_PREVIEW",
}

export const turnStatesConcurrent = {
  INTRO: "TURN_CONC_INTRO",
  QUESTION: "TURN_CONC_QUESTION",
  READY: "TURN_CONC_READY",
}

export const actions = {
  HOST_ACTION: "host_action",
  HOST_START_INTRO: "HOST_START_INTRO",
  HOST_START_ROUNDS: "HOST_START_ROUNDS",
  HOST_START_PLAYER_TURNS: "HOST_START_PLAYER_TURNS",
  HOST_CONFIRM_REDISTRIBUTE: "HOST_CONFIRM_REDISTRIBUTE",
  HOST_REDISTRIBUTE_TO_PLAYER: "HOST_REDISTRIBUTE_TO_PLAYER",
  HOST_RESET_REDISTRIBUTE: "HOST_RESET_REDISTRIBUTE",
  HOST_PREPARE_NEXT_ROUND: "HOST_PREPARE_NEXT_ROUND",
  HOST_END_GAME: "HOST_END_GAME",
  HOST_RECONNECT: "HOST_RECONNECT",

  PLAYER_ACTION: "game_player_action",
  PLAYER_DRAWS_CARD: "PLAYER_DRAWS_CARD",
  PLAYER_CHOOSES_OPTION: "PLAYER_CHOOSES_OPTION",
  PLAYER_CONFIRMS_OPTION: "PLAYER_CONFIRMS_OPTION",
  PLAYER_REDISTRIBUTE_TO_HOST: "PLAYER_REDISTRIBUTE_TO_HOST",
  PLAYER_RECONNECT: "PLAYER_RECONNECT",
}

export const layouts = {
  VERTICAL_CENTER: "vertical-center",
  HORIZONTAL_LEFT: "horizontal-left",
}
